// Iter 131 — Kalkulator harga otomatis untuk pesanan Custom + proses murni Bordir.
// Iter 133 — Diperluas ke seluruh produk yang bisa dipetakan pasti ke master aplikasi.
//   Referensi: Katalog Produk TAMFARIS. Rumus tetap sama (base + extra points + sleeve add).
//   Harga sudah termasuk 1 titik bordir; extra rate berlaku untuk titik ke-2+.
//   Pemetaan ambigu (Tactical American/Bomber/Jas Almamater/Rompi Gelembung/Rompi Ripstop
//   Premium/Rompi Taslan Jaring/Rompi Taslan Polar) TIDAK diterapkan — laporkan ke user.
//
// Semua fungsi pure (no side effect). Digunakan oleh <AutoPriceControl/> di App.js.

// Tarif tambahan per titik bordir DI ATAS titik pertama, per pcs — sama untuk semua produk.
// Iter 149 — Diekspor supaya UI bisa menghitung ulang effective per baris ketika titik
// bordir per variasi berubah (tanpa perlu menjalankan kalkulator lengkap ulang).
export function extraPointRate(qty) {
  if (!Number.isInteger(qty) || qty < 1) return null;
  if (qty <= 23) return 10000;
  if (qty <= 99) return 8000;
  if (qty <= 299) return 7000;
  return 6000;
}

// Konfigurasi sleeve per kategori produk.
// { Panjang: number, Pendek: 0 } → wajib pilih Pendek/Panjang, validasi sleeve.
// null                         → produk tidak punya opsi lengan; sleeve tidak divalidasi.
const SLEEVE_ADD_15K = { Panjang: 15000, Pendek: 0 };
const SLEEVE_ADD_10K = { Panjang: 10000, Pendek: 0 };
const SLEEVE_NONE = null;

// Helper untuk build fungsi tier price dari list `[[min, max_or_Inf, price], ...]`.
function tierPriceFn(tiers) {
  return (qty) => {
    if (!Number.isInteger(qty) || qty < 1) return null;
    for (const [mn, mx, price] of tiers) {
      if (qty >= mn && qty <= mx) return price;
    }
    return null;
  };
}

const T_INF = Number.POSITIVE_INFINITY;

// Tabel harga per produk (sumber: Katalog Produk TAMFARIS).
const T_PDH = [[1,4,120000],[5,6,115000],[7,11,106000],[12,23,103000],[24,49,98000],[50,99,97000],[100,299,96000],[300,999,95000],[1000,T_INF,92000]];
const T_PDH_NAGATA = [[1,4,154000],[5,6,149000],[7,11,138000],[12,23,133000],[24,49,126000],[50,99,126000],[100,299,125000],[300,999,123000],[1000,T_INF,120000]];
const T_POLO_CVC = [[1,4,120000],[5,6,115000],[7,11,106000],[12,23,103000],[24,49,98000],[50,99,97000],[100,299,96000],[300,999,95000],[1000,T_INF,92000]];
const T_POLO_PE = [[1,4,75000],[5,6,67000],[7,11,62000],[12,23,60000],[24,49,58000],[50,99,57000],[100,299,56000],[300,999,55000],[1000,T_INF,54000]];
const T_WORKSHIRT = [[1,4,120000],[5,6,115000],[7,11,106000],[12,23,103000],[24,49,98000],[50,99,97000],[100,299,96000],[300,999,94000],[1000,T_INF,92000]];
const T_VARSITY = [[1,4,125000],[5,6,121000],[7,11,112000],[12,23,108000],[24,49,104000],[50,99,102000],[100,299,101000],[300,999,100000],[1000,T_INF,97000]];
const T_ROMPI_AMERICAN = [[1,4,115000],[5,6,111000],[7,11,103000],[12,23,100000],[24,49,96000],[50,99,94000],[100,299,93000],[300,999,92000],[1000,T_INF,90000]];
// Iter 134 — Tabel tambahan dari katalog TAMFARIS.
const T_TACTICAL = [[1,4,157000],[5,6,152000],[7,11,141000],[12,23,136000],[24,49,131000],[50,99,129000],[100,299,126000],[300,999,125000],[1000,T_INF,123000]];
const T_BOMBER = [[1,4,155000],[5,6,150000],[7,11,138000],[12,23,133000],[24,49,128000],[50,99,126000],[100,299,125000],[300,999,123000],[1000,T_INF,120000]];
const T_ALMAMATER = [[1,4,200000],[5,6,194000],[7,11,181000],[12,23,174000],[24,49,167000],[50,99,164000],[100,299,163000],[300,999,160000],[1000,T_INF,155000]];
const T_ROMPI_GELEMBUNG = [[1,4,102000],[5,6,99000],[7,11,92000],[12,23,89000],[24,49,85000],[50,99,84000],[100,299,83000],[300,999,82000],[1000,T_INF,80000]];
const T_ROMPI_RIPSTOP_PREMIUM = [[1,4,127000],[5,6,123000],[7,11,114000],[12,23,110000],[24,49,106000],[50,99,104000],[100,299,103000],[300,999,101000],[1000,T_INF,99000]];
const T_ROMPI_TASLAN = [[1,4,135000],[5,6,130000],[7,11,121000],[12,23,116000],[24,49,111000],[50,99,109000],[100,299,108000],[300,999,106000],[1000,T_INF,103000]];

// Iter 208 — Tabel harga PAKET Kaos Combed 24s + Sablon DTF (harga sudah termasuk sablon DTF).
//   Baris = tier qty, Kolom = ukuran sablon (A5/A4/A3/A3+). Tambahan ukuran garment & lengan
//   dihitung terpisah (lihat sizeUpcharge & sleeveAddFor).
const T_COMBED_DTF = {
  A5:  [[1,11,65000],[12,23,59000],[24,49,57000],[50,99,55000],[100,199,54000],[200,999,53000],[1000,T_INF,51000]],
  A4:  [[1,11,75000],[12,23,64000],[24,49,61000],[50,99,59000],[100,199,58000],[200,999,56000],[1000,T_INF,54000]],
  A3:  [[1,11,85000],[12,23,74000],[24,49,72000],[50,99,69000],[100,199,68000],[200,999,66000],[1000,T_INF,63000]],
  "A3+":[[1,11,90000],[12,23,80000],[24,49,77000],[50,99,74000],[100,199,72000],[200,999,70000],[1000,T_INF,68000]],
};
// Sleeve khusus Combed 24s: Panjang +Rp10rb, Pendek 0 (sama pola dgn Polo CVC/PE tapi konstanta beda).
const SLEEVE_ADD_COMBED = { Panjang: 10000, Pendek: 0 };
// Tier price 2D untuk basePrice(qty, dtfSize). Bila dtfSize tidak ada di tabel → null.
function combedDtfBasePrice(qty, dtfSize) {
  if (!Number.isInteger(qty) || qty < 1) return null;
  const table = T_COMBED_DTF[String(dtfSize || "").trim()];
  if (!table) return null;
  for (const [mn, mx, price] of table) if (qty >= mn && qty <= mx) return price;
  return null;
}
export const DTF_SIZES = ["A5","A4","A3","A3+"];

// Pemetaan produk → varian pricing. Setiap varian punya:
//   - `label`: label yang muncul di hint tombol
//   - `basePrice(qty)`: harga per pcs sudah termasuk 1 titik
//   - `sleeveAdd`: konfigurasi lengan (lihat konstanta di atas)
//   - `materialMatch?`: bila hadir, hanya berlaku bila material sama (case-sensitive)
//   - `materialExclude?`: bila hadir dan material cocok, varian tsb SKIP (untuk PDH biasa yang
//     mengecualikan Nagata Drill).
const PRICING_VARIANTS = {
  "Kemeja PDH": [
    // Urutan penting: cek Nagata dulu, fallback ke regular bila material bukan Nagata.
    { label: "PDH Nagata", basePrice: tierPriceFn(T_PDH_NAGATA), sleeveAdd: SLEEVE_ADD_15K, materialMatch: "Nagata Drill" },
    { label: "PDH", basePrice: tierPriceFn(T_PDH), sleeveAdd: SLEEVE_ADD_15K, materialExclude: "Nagata Drill" },
  ],
  // Iter 137 — Varian eksplisit (material sudah tergabung di nama produk).
  // Iter 200 — Alias nama BAKU pengguna (nama lama dipertahankan sebagai fallback kompatibilitas nota historis).
  "PDH American Drill": [{ label: "PDH", basePrice: tierPriceFn(T_PDH), sleeveAdd: SLEEVE_ADD_15K }],
  "PDH Nagata Drill": [{ label: "PDH Nagata", basePrice: tierPriceFn(T_PDH_NAGATA), sleeveAdd: SLEEVE_ADD_15K }],
  "Rompi American Drill": [{ label: "Rompi American", basePrice: tierPriceFn(T_ROMPI_AMERICAN), sleeveAdd: SLEEVE_NONE }],
  "Tactical American": [{ label: "Kemeja Tactical American", basePrice: tierPriceFn(T_TACTICAL), sleeveAdd: SLEEVE_ADD_15K }],
  "Bomber": [{ label: "Jaket Bomber", basePrice: tierPriceFn(T_BOMBER), sleeveAdd: SLEEVE_NONE }],
  "Tactical American Drill": [{ label: "Kemeja Tactical American", basePrice: tierPriceFn(T_TACTICAL), sleeveAdd: SLEEVE_ADD_15K }],
  "Jaket Varsity": [{ label: "Varsity", basePrice: tierPriceFn(T_VARSITY), sleeveAdd: SLEEVE_NONE }],
  // Nama lama (kompatibilitas nota historis / sebelum Iter 200).
  "Kemeja PDH American": [{ label: "PDH", basePrice: tierPriceFn(T_PDH), sleeveAdd: SLEEVE_ADD_15K }],
  "Kemeja PDH Nagata": [{ label: "PDH Nagata", basePrice: tierPriceFn(T_PDH_NAGATA), sleeveAdd: SLEEVE_ADD_15K }],
  "Rompi American": [{ label: "Rompi American", basePrice: tierPriceFn(T_ROMPI_AMERICAN), sleeveAdd: SLEEVE_NONE }],
  "Polo CVC": [{ label: "Polo CVC", basePrice: tierPriceFn(T_POLO_CVC), sleeveAdd: SLEEVE_ADD_10K }],
  "Polo PE": [{ label: "Polo PE", basePrice: tierPriceFn(T_POLO_PE), sleeveAdd: SLEEVE_ADD_10K }],
  "Workshirt": [{ label: "Workshirt", basePrice: tierPriceFn(T_WORKSHIRT), sleeveAdd: SLEEVE_ADD_15K }],
  "Varsity": [{ label: "Varsity", basePrice: tierPriceFn(T_VARSITY), sleeveAdd: SLEEVE_NONE }],
  "Rompi": [
    // Hanya berlaku bila material spesifik cocok. Selain itu, ambigu → tombol disembunyikan.
    { label: "Rompi American", basePrice: tierPriceFn(T_ROMPI_AMERICAN), sleeveAdd: SLEEVE_NONE, materialMatch: "American Drill" },
  ],
  // Iter 134 — Varian katalog dengan nama produk terpisah (bukan alias generic Rompi/Jaket).
  "Kemeja Tactical American": [{ label: "Kemeja Tactical American", basePrice: tierPriceFn(T_TACTICAL), sleeveAdd: SLEEVE_ADD_15K }],
  "Jaket Bomber": [{ label: "Jaket Bomber", basePrice: tierPriceFn(T_BOMBER), sleeveAdd: SLEEVE_NONE }],
  "Jas Almamater": [{ label: "Jas Almamater", basePrice: tierPriceFn(T_ALMAMATER), sleeveAdd: SLEEVE_NONE }],
  "Rompi Gelembung": [{ label: "Rompi Gelembung", basePrice: tierPriceFn(T_ROMPI_GELEMBUNG), sleeveAdd: SLEEVE_NONE }],
  "Rompi Ripstop Premium": [{ label: "Rompi Ripstop Premium", basePrice: tierPriceFn(T_ROMPI_RIPSTOP_PREMIUM), sleeveAdd: SLEEVE_NONE }],
  "Rompi Taslan Jaring": [{ label: "Rompi Taslan Jaring", basePrice: tierPriceFn(T_ROMPI_TASLAN), sleeveAdd: SLEEVE_NONE }],
  "Rompi Taslan Polar": [{ label: "Rompi Taslan Polar", basePrice: tierPriceFn(T_ROMPI_TASLAN), sleeveAdd: SLEEVE_NONE }],
  // Iter 208 — Kaos Combed 24s + Sablon DTF. Alias by-name fallback bila pricing_key belum sync.
  "Kaos Combed 24s": [{ label: "Kaos Combed 24s (DTF)", basePrice: combedDtfBasePrice, sleeveAdd: SLEEVE_ADD_COMBED, dtf: true, route: "sablon_dtf" }],
};

// Iter 150 — Pemetaan berbasis kunci stabil. `pricing_key` disimpan di master_products dan
//   ikut disertakan pada `product.pricing_key` saat form nota memilih produk. Perubahan
//   nama tampilan (mis. "Polo PE" → "Polo PE Premium") tidak memutus kalkulator karena
//   lookup pakai kunci. Nota lama tanpa `pricing_key` → fallback ke `PRICING_VARIANTS`
//   (map by name) untuk kompatibilitas historis.
const PRICING_BY_KEY = {
  "polo_pe":                  { label: "Polo PE",                basePrice: tierPriceFn(T_POLO_PE),                sleeveAdd: SLEEVE_ADD_10K },
  "polo_cvc":                 { label: "Polo CVC",               basePrice: tierPriceFn(T_POLO_CVC),               sleeveAdd: SLEEVE_ADD_10K },
  "workshirt":                { label: "Workshirt",              basePrice: tierPriceFn(T_WORKSHIRT),              sleeveAdd: SLEEVE_ADD_15K },
  "varsity":                  { label: "Varsity",                basePrice: tierPriceFn(T_VARSITY),                sleeveAdd: SLEEVE_NONE },
  "pdh_american":             { label: "PDH",                    basePrice: tierPriceFn(T_PDH),                    sleeveAdd: SLEEVE_ADD_15K },
  "pdh_nagata":               { label: "PDH Nagata",             basePrice: tierPriceFn(T_PDH_NAGATA),             sleeveAdd: SLEEVE_ADD_15K },
  "rompi_american":           { label: "Rompi American",         basePrice: tierPriceFn(T_ROMPI_AMERICAN),         sleeveAdd: SLEEVE_NONE },
  "kemeja_tactical_american": { label: "Kemeja Tactical American", basePrice: tierPriceFn(T_TACTICAL),             sleeveAdd: SLEEVE_ADD_15K },
  "jaket_bomber":             { label: "Jaket Bomber",           basePrice: tierPriceFn(T_BOMBER),                 sleeveAdd: SLEEVE_NONE },
  "jas_almamater":            { label: "Jas Almamater",          basePrice: tierPriceFn(T_ALMAMATER),              sleeveAdd: SLEEVE_NONE },
  "rompi_gelembung":          { label: "Rompi Gelembung",        basePrice: tierPriceFn(T_ROMPI_GELEMBUNG),        sleeveAdd: SLEEVE_NONE },
  "rompi_ripstop_premium":    { label: "Rompi Ripstop Premium",  basePrice: tierPriceFn(T_ROMPI_RIPSTOP_PREMIUM),  sleeveAdd: SLEEVE_NONE },
  "rompi_taslan_jaring":      { label: "Rompi Taslan Jaring",    basePrice: tierPriceFn(T_ROMPI_TASLAN),           sleeveAdd: SLEEVE_NONE },
  "rompi_taslan_polar":       { label: "Rompi Taslan Polar",     basePrice: tierPriceFn(T_ROMPI_TASLAN),           sleeveAdd: SLEEVE_NONE },
  // Iter 208 — Kaos Combed 24s + DTF. `basePrice` menerima (qty, dtfSize) sebagai tabel 2D.
  //   `dtf` flag menandai varian memerlukan dropdown ukuran sablon DTF di UI produk.
  "kaos_combed_24s_dtf":      { label: "Kaos Combed 24s (DTF)",   basePrice: combedDtfBasePrice,                    sleeveAdd: SLEEVE_ADD_COMBED, dtf: true, route: "sablon_dtf" },
};

export function pricingKeyExists(pricingKey) {
  return !!(pricingKey && Object.prototype.hasOwnProperty.call(PRICING_BY_KEY, pricingKey));
}

function pickVariant(productName, material, pricingKey) {
  // Prioritas: pricing_key (stabil) → nama produk (legacy fallback demi nota lama).
  if (pricingKey && PRICING_BY_KEY[pricingKey]) return PRICING_BY_KEY[pricingKey];
  const variants = PRICING_VARIANTS[productName];
  if (!variants) return null;
  const mat = String(material || "").trim();
  for (const v of variants) {
    if (v.materialMatch && v.materialMatch !== mat) continue;
    if (v.materialExclude && v.materialExclude === mat) continue;
    return v;
  }
  return null;
}

// Label pendek untuk hint tombol Hitung Harga (mis. "PDH", "Polo CVC", "Rompi American").
// Return null bila kombinasi produk/material tidak eligible.
export function autoPriceLabel(productName, material, pricingKey) {
  const v = pickVariant(productName, material, pricingKey);
  return v ? v.label : null;
}

// Apakah produk/material membutuhkan pemilihan lengan (Pendek/Panjang)? Digunakan UI
// untuk menyembunyikan hint "lengan …" pada produk seperti Varsity/Rompi/Bomber.
export function autoPriceNeedsSleeve(productName, material, pricingKey) {
  const v = pickVariant(productName, material, pricingKey);
  return !!(v && v.sleeveAdd);
}

export function isAutoPriceEligible({ orderType, productName, material, productionRoute, pricingKey }) {
  if (orderType !== "Custom") return false;
  const v = pickVariant(productName, material, pricingKey);
  if (!v) return false;
  // Iter 208 — Varian DTF (kaos_combed_24s_dtf) berlaku untuk route Sablon (DTF).
  //   Varian lain (Bordir-based) tetap wajib route "Bordir".
  if (v.route === "sablon_dtf") return productionRoute === "Sablon (DTF)";
  return productionRoute === "Bordir";
}

// Iter 208 — Apakah varian membutuhkan dropdown ukuran sablon DTF di kartu produk?
export function autoPriceNeedsDtfSize(productName, material, pricingKey) {
  const v = pickVariant(productName, material, pricingKey);
  return !!(v && v.dtf === true);
}

/**
 * @returns {ok:false, reason:string} | {ok:true, price:number, breakdown:{base,extraPoints,rate,sleeveAdd,qty}, label:string}
 */
export function computeAutoPrice({ orderType, productName, material, productionRoute, totalQty, embroideryPoints, sleeve, pricingKey, dtfSize }) {
  if (orderType !== "Custom") return { ok: false, reason: "not_eligible" };
  const variant = pickVariant(productName, material, pricingKey);
  if (!variant) return { ok: false, reason: "not_eligible" };
  // Iter 208 — Route eligibility per-varian.
  if (variant.route === "sablon_dtf") {
    if (productionRoute !== "Sablon (DTF)") return { ok: false, reason: "not_eligible" };
    if (!DTF_SIZES.includes(String(dtfSize || "").trim())) return { ok: false, reason: "invalid_dtf_size" };
  } else {
    if (productionRoute !== "Bordir") return { ok: false, reason: "not_eligible" };
  }

  const qty = Number(totalQty);
  if (!Number.isInteger(qty) || qty < 1) return { ok: false, reason: "invalid_qty" };

  let sleeveAdd = 0;
  if (variant.sleeveAdd) {
    if (!(sleeve in variant.sleeveAdd)) return { ok: false, reason: "invalid_sleeve" };
    sleeveAdd = variant.sleeveAdd[sleeve];
  }
  // basePrice signature bergantung varian:
  //   • Bordir-based → basePrice(qty)
  //   • DTF-based    → basePrice(qty, dtfSize)
  const base = variant.dtf ? variant.basePrice(qty, dtfSize) : variant.basePrice(qty);
  if (base === null) return { ok: false, reason: "invalid_qty" };

  // Titik bordir hanya berlaku untuk varian Bordir; DTF tidak pakai extraPoints.
  let extraPoints = 0, rate = 0;
  if (!variant.dtf) {
    const pts = Number(embroideryPoints);
    if (!Number.isInteger(pts) || pts < 1) return { ok: false, reason: "invalid_points" };
    rate = extraPointRate(qty);
    if (rate === null) return { ok: false, reason: "invalid_qty" };
    extraPoints = Math.max(pts - 1, 0);
  }
  const price = base + extraPoints * rate + sleeveAdd;
  return { ok: true, price, label: variant.label, breakdown: { base, extraPoints, rate, sleeveAdd, qty } };
}

// Signature detail yang mempengaruhi harga. Dipakai untuk mendeteksi "detail berubah setelah hitung".
// Iter 138 — sertakan distribusi ukuran karena tambahan ukuran (2XL/3XL/4XL/5XL) memengaruhi harga per baris.
export function priceSignature({ productName, material, productionRoute, totalQty, embroideryPoints, sleeve, sizes }) {
  const sizeSig = Array.isArray(sizes)
    ? sizes
        // Iter 145 — Sertakan `variant` (Panjang/Pendek) karena kalkulator memakainya sebagai
        // pengganti global sleeve untuk menentukan tambahan lengan panjang per baris.
        .map(s => `${normalizeSizeName(s.size)}:${Number(s.quantity || 0)}:${(s.variant || "").trim()}`)
        .filter(t => !t.startsWith(":"))
        .sort()
        .join(",")
    : "";
  return [productName || "", material || "", productionRoute || "", totalQty ?? 0, embroideryPoints ?? 0, sleeve || "", sizeSig].join("|");
}

// Iter 138 — Tambahan harga per ukuran, diterapkan SEKALI di atas harga kalkulator (yang sudah mencakup bordir+lengan).
//   • Kaos*         : tanpa tambahan (mengikuti aturan sebelumnya)
//   • Polo PE       : 2XL/3XL = +Rp5.000/pcs, 4XL/5XL = +Rp10.000/pcs
//   • Selain di atas: 2XL/3XL = +Rp10.000/pcs, 4XL/5XL = +Rp20.000/pcs
// Aturan produk dievaluasi via prefix nama produk agar konsisten dengan katalog master
// (mis. "Kaos Combed" → prefix "Kaos"). Ukuran dinormalisasi (XXL≡2XL, XXXL≡3XL, XXXXL≡4XL, XXXXXL≡5XL).
export function normalizeSizeName(size) {
  const s = String(size || "").trim().toUpperCase();
  if (!s) return "";
  if (s === "XXL" || s === "2XL") return "2XL";
  if (s === "XXXL" || s === "3XL") return "3XL";
  if (s === "XXXXL" || s === "4XL") return "4XL";
  if (s === "XXXXXL" || s === "5XL") return "5XL";
  return s;
}

function isKaosProduct(productName) {
  return /^kaos\b/i.test(String(productName || "").trim());
}

// Iter 208 — Kaos Combed 24s memakai upcharge Polo-PE-like meskipun prefix "Kaos".
function isKaosCombed24s(productName) {
  return String(productName || "").trim() === "Kaos Combed 24s";
}

export function sizeUpcharge(productName, sizeName) {
  const n = normalizeSizeName(sizeName);
  if (!n) return 0;
  if (isKaosCombed24s(productName)) {
    // Iter 208 — 2XL/3XL +Rp5rb, 4XL/5XL +Rp10rb (khusus DTF kaos combed).
    if (n === "2XL" || n === "3XL") return 5000;
    if (n === "4XL" || n === "5XL") return 10000;
    return 0;
  }
  if (isKaosProduct(productName)) return 0; // Kaos lain tanpa tambahan.
  const isPoloPE = String(productName || "").trim() === "Polo PE";
  if (isPoloPE) {
    if (n === "2XL" || n === "3XL") return 5000;
    if (n === "4XL" || n === "5XL") return 10000;
    return 0;
  }
  // Produk lain (termasuk Polo CVC, PDH, dsb.):
  if (n === "2XL" || n === "3XL") return 10000;
  if (n === "4XL" || n === "5XL") return 20000;
  return 0;
}

// Ringkasan aturan tambahan ukuran untuk hint UI. Return null → tidak ada tambahan (mis. Kaos).
export function sizeUpchargeSummary(productName) {
  if (isKaosCombed24s(productName)) return "2XL/3XL +Rp5rb · 4XL/5XL +Rp10rb per pcs";
  if (isKaosProduct(productName)) return null;
  if (String(productName || "").trim() === "Polo PE") return "2XL/3XL +Rp5rb · 4XL/5XL +Rp10rb per pcs";
  return "2XL/3XL +Rp10rb · 4XL/5XL +Rp20rb per pcs";
}

// Iter 148 — Tambahan lengan untuk produk tertentu. Digunakan saat menghitung ulang harga
// per baris variasi ketika user mengubah lengan (Panjang/Pendek) TANPA menekan Hitung Harga
// lagi — komponen tambahan bersifat idempoten (bukan akumulasi).
export function sleeveAddFor(productName, material, sleeve, pricingKey) {
  const v = pickVariant(productName, material, pricingKey);
  if (!v || !v.sleeveAdd) return 0;
  if (!(sleeve === "Panjang" || sleeve === "Pendek")) return 0;
  return Number(v.sleeveAdd[sleeve] || 0);
}

// Iter 137 — Mapping nama produk → bahan default. Digunakan saat user memilih produk
// pada form nota (dropdown Bahan sudah dihapus). Nilai bahan diauto-set berdasarkan
// pilihan produk. Bila produk tidak tercantum di sini, bahan dikosongkan (form tidak
// menebak). SPK/produksi/PDF membaca `products[].material` seperti biasa — kolom ini
// tetap ada di data model (nota lama tidak berubah).
export const PRODUCT_MATERIAL_MAP = {
  // Iter 200 — Nama baku 14 produk.
  "PDH American Drill": "American Drill",
  "PDH Nagata Drill": "Nagata Drill",
  "Polo PE": "PE",
  "Polo CVC": "CVC",
  "Tactical American": "American Drill",
  "Tactical American Drill": "American Drill",
  "Workshirt": "American Drill",
  "Rompi American Drill": "American Drill",
  "Rompi Gelembung": "Taslan Gelembung",
  "Rompi Ripstop Premium": "Ripstop Premium",
  "Rompi Taslan Jaring": "Taslan Jaring",
  "Rompi Taslan Polar": "Taslan Polar",
  // Iter 208 — Kaos Combed 24s + DTF (untuk kalkulator Sablon DTF).
  "Kaos Combed 24s": "Combed 24s",
  // Nama lama (kompatibilitas nota historis).
  "Kemeja PDH American": "American Drill",
  "Kemeja PDH Nagata": "Nagata Drill",
  "Kemeja Tactical American": "American Drill",
  "Rompi American": "American Drill",
  // Sisanya (Bomber, Varsity, Jas Almamater) tidak dipetakan otomatis — user isi manual bila perlu.
};

export function materialForProduct(productName) {
  return PRODUCT_MATERIAL_MAP[productName] || "";
}

// Untuk kompatibilitas dgn kode Iter 131 (tidak dipakai UI baru, hanya export lama).
export const PDH_ELIGIBLE_PRODUCT = "Kemeja PDH";
export const PDH_EXCLUDED_MATERIALS = new Set(["Nagata Drill"]);
